/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

export type Pronoun = (typeof Pronoun)[keyof typeof Pronoun];

export const Pronoun = {
  "He_/_him": "He / him",
  "She_/_her": "She / her",
  "They_/_them": "They / them",
} as const;
